import { AiOutlineSearch } from "react-icons/ai"; 
import React from 'react';
import { Table, Input, Button } from 'antd';
import type { TableProps } from 'antd';

interface DataTableProps<T> {
  data: T[];
  columns: TableProps<T>['columns'];
  loading?: boolean;
  selectable?: boolean;
  onSelectionChange?: (selectedRows: T[]) => void;
}

function DataTable<T extends { id: string }>({
  data,
  columns,
  loading,
  selectable,
  onSelectionChange,
}: DataTableProps<T>) {
  const [searchText, setSearchText] = React.useState('');
  const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>([]);

  const filteredData = React.useMemo(() => {
    if (!Array.isArray(data)) return []; 
    return data.filter((item) =>
      Object.values(item).some(
        (value) =>
          value && value.toString().toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [data, searchText]);
  

  const rowSelection = selectable
    ? {
        selectedRowKeys,
        onChange: (selectedKeys: React.Key[], selectedRows: T[]) => {
          setSelectedRowKeys(selectedKeys);
          onSelectionChange?.(selectedRows);
        },
      }
    : undefined;

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-4">
        <div className="flex-1 relative">
          <Input
            prefix={<AiOutlineSearch />}
            // prefix={<Search className="h-4 w-4 text-gray-400" />}
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="w-full"
          />
        </div>
        {selectable && selectedRowKeys.length > 0 && (
          <Button
            onClick={() => {
              setSelectedRowKeys([]);
              onSelectionChange?.([]);
            }}
          >
            Clear Selection
          </Button>
        )}
      </div>

      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={filteredData}
        loading={loading}
        rowKey="id"
        pagination={{
          total: filteredData.length,
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} items`,
        }}
      />
    </div>
  );
}

export default DataTable;